var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<span uib-dropdown><a href uib-dropdown-toggle><i class=\"m-l-1 fa fa-lg fa-{{::$ctrl.icon||'wrench'}}\"></i></a><ul uib-dropdown-menu ng-transclude class=\"pull-right\"><li><a href>Config option 1</a></li><li><a href>Config option 2</a></li></ul></span>";
var id1="ibox.toolbar.menu.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;